<template>
  <div>
    <header-image
      :headerContents="headerContents"
      :headerBackground="'clients'"
    />

    <call-out-box
      :CallOutTitle="'Hire the UK\'s best early talent.'"
      :IsH2="true"
    />

    <clients-attraction-delvelopment/>

    <call-out-box
      :CallOutTitle="'WE DON’T JUST IDENTIFY TALENT, WE DEVELOP IT.'"
      :CallOutBody="'The support we offer our candidates is tailored to their individual needs. We never spoon-feed our candidates; we encourage them to think for themselves, to figure things out and to pursue knowledge independently.'"
      :CallOutBodySmall="'The support we offer our candidates is tailored to their individual needs. We never spoon-feed our candidates; we encourage them to think for themselves, to figure things out and to pursue knowledge independently.'"
      :CallOutColor="'grey'"
    />

    <rare-person-quote
      :quoteTitle="'The best development'"
      :quoteBody="'Rare doesn\'t make the process easier, it makes the candidate better.'"
      :quoteName="'Sengova Kailondo'"
      :quotePosition="'Asset Finance Lawyer and Rare alumnus'"
      :quoteLogoImage="'HoganLovells'"
      :quotePortraightImage="'SengovaKailondo'"
      :quoteImageSide="'right'"
    />

    <rare-contact-form :product="'Attraction & Development'" />

    <rare-awards/>
  </div>
</template>

<script>

import HeaderHeroImage from '../../../components/header/HeaderHeroImage';
import RareCallOutBox from '../../../components/commonSections/RareCallOutBox';
import RarePersonQuote from '../../../components/commonSections/RarePersonQuote';
import RareContactForm from '../../../components/forms/RareContactForm';

import RareHomeProductsHeaderContents from './components/RareHomeProductsHeaderContents';
import RareHomeProductsAttractionDevelopment from './components/RareHomeProductsAttractionDevelopment';
import RareAwards from '../../../components/carousels/awardsCarousel';

export default {
  name: 'HomeProductsAttractionAndDevelopment',
  components: {
    'header-image': HeaderHeroImage,
    'rare-clients-header-contents': RareHomeProductsHeaderContents,
    'rare-person-quote': RarePersonQuote,
    'call-out-box': RareCallOutBox,
    'clients-attraction-delvelopment': RareHomeProductsAttractionDevelopment,
    'rare-awards': RareAwards,
    'rare-contact-form': RareContactForm,
  },
  data() {
    return {
      headerContents: 'rare-clients-header-contents',
    };
  },
  mounted() {
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/homeProducts/homeProductsAttractionAndDevelopment/homeProductsAttractionAndDevelopment.vue